import { render, staticRenderFns } from "./CaseImgModelSelectDia.vue?vue&type=template&id=e2f647ca&scoped=true"
import script from "./CaseImgModelSelectDia.vue?vue&type=script&lang=js"
export * from "./CaseImgModelSelectDia.vue?vue&type=script&lang=js"
import style0 from "./CaseImgModelSelectDia.vue?vue&type=style&index=0&id=e2f647ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f647ca",
  null
  
)

export default component.exports